export default {
    Name: 'Name',
    'Phone Number': 'Phone Number',
    Phone: 'Phone',
    Email: 'Email',
    Actions: 'Actions',
    Code: 'Code',
    'AMF Code': 'AMF Code',
    Username: 'Username',
    Password: 'Password',
    'Confirm Password': 'Confirm Password',
    'AMF Username': 'AMF Username',
    'AMF Password': 'AMF Password',
    Serial: 'Serial',
    'Policy Holder': 'Policy Holder',
    'Product Code': 'Product Code',
    Currency: 'Currency',
    Status: 'Status',
    'Premium Gross': 'Premium Gross',
    'Premium Net': 'Premium Net',
    'Issued Date': 'Issued Date',
    'Start Date': 'Start Date',
    'End Date': 'End Date',
    Agency: 'Agency',
    'Find Agency by Tax Number': 'Find Agency by Tax Number',
    'Agency Commission Rate': 'Agency Commission Rate',
    Agent: 'Agent',
    Intermediary: 'Intermediary',
    'Intermediary Commission Rate': 'Intermediary Commission Rate',
    Underwriter: 'Underwriter',
    Contact: 'Contact',
    'Select Departament': 'Select Departament',
    'All Departments': 'All Departments',
    'Health Department': 'Health Department',
    'Property Department': 'Property Department',
    'Motor Department': 'Motor Department',
    'Tax Number': 'Tax Number',
    'Display Name': 'Display Name',
    Country: 'Country',
    City: 'City',
    'Postal Code': 'Postal Code',
    'Street Address': 'Street Address',
    'Street Address 2': 'Street Address 2',
    Duration: 'Duration',
    'Distribution Channel': 'Distribution Channel',
    Broker: 'Broker',
    Bank: 'Bank',
    'First Name': 'First Name',
    'Last Name': 'Last Name',
    Customer: 'Customer',
    Commission: 'Commission',
    Notes: 'Notes',
    'Choose Type': 'Choose Type',
    Person: 'Person',
    Organization: 'Organization',
    Local: 'Local',
    'Business Size Type': 'Business Size Type',
    'Business Size': 'Business Size',
    'Legal Form Type': 'Legal Form Type',
    'Sector Type': 'Sector Type',
    'Organization Ownership Type': 'Organization Ownership Type',
    Administrator: 'Administrator',
    Active: 'Active',
    'Business Description': 'Business Description',
    "Father's Name": "Father's Name",
    Birthday: 'Birthday',
    'Choose Gender': 'Choose Gender',
    Gender: 'Gender',
    Female: 'Female',
    Male: 'Male',
    Other: 'Other',
    'Hospital Type': 'Hospital Type',
    Website: 'Website',
    'Insurance Sector Type': 'Insurance Sector Type',
    'Tax Rate': 'Tax Rate',
    'Agent Commission Rate': 'Agent Commission Rate',
    'Bonus Commission Rate': 'Bonus Commission Rate',
    'Bonus Commission Rate Cap': 'Bonus Commission Rate Cap',
    'AMF Contribution Rate': 'AMF Contribution Rate',
    'Dynamic Durations': 'Dynamic Durations',
    Group: 'Group',
    'Transit Type': 'Transit Type',
    'Security Measures': 'Security Measures',
    Description: 'Description',
    'Location of the insured property': 'Location of the insured property',
    'Special Coverage': 'Special Coverage',
    Years: 'Years',
    Months: 'Months',
    Days: 'Days',
    Default: 'Default',
    'Serial Start': 'Serial Start',
    'Serial End': 'Serial End',
    Destination: 'Destination',
    'Gjithe Europa': 'Gjithe Europa',
    'Insured Period': 'Insured Period',
    Beneficiary: 'Beneficiary',
    'The policyholder is the same as the beneficiary': 'The policyholder is the same as the beneficiary',
    'Completion Date': 'Completion Date',
    'Write the Serial': 'Write the Serial',
    'Vehicle Value': 'Vehicle Value',
    Payment: 'Payment',
    'Payment Method': 'Payment Method',
    'Seriali TPL': 'Seriali TPL',
    'Gross Premium': 'Gross Premium',
    Address: 'Address',
    Clinic: 'Clinic',
    Dentistry: 'Dentistry',
    Hospital: 'Hospital',
    Laboratory: 'Laboratory',
    Optical: 'Optical',
    Pharmacy: 'Pharmacy',
    Physiotherapy: 'Physiotherapy',
    'Large Enterprise': 'Large Enterprise',
    'Small Enterprise no VAT': 'Small Enterprise no VAT',
    'Small Enterprise with VAT': 'Small Enterprise with VAT',
    'Small-Medium Enterprise': 'Small-Medium Enterprise',
    'VIP Enterprise': 'VIP Enterprise',
    'Person Fizik': 'Person Fizik',
    'Shoqëri me përgjegjësi të kufizuar': 'Shoqëri me përgjegjësi të kufizuara',
    'Organizatë jo fitimprurëse': 'Organizatë jo fitimprurëse',
    'Gjithë të tjerat': 'Gjithë të tjerat',
    'Ent Publik': 'Ent Publik',
    'Shoqëri Aksionare': 'Shoqëri Aksionare',
    'Construction sector': 'Construction sector',
    'Other sectors': 'Other sectors',
    'Production sector': 'Production sector',
    'Service sector': 'Service sector',
    'Trade sector': 'Trade sector',
    'Transport sector': 'Transport sector',
    Foreign: 'Foreign',
    Government: 'Government',
    'Local foreign': 'Local foreign',
    'Health department': 'Health department',
    'Marine department': 'Marine department',
    'Motor department': 'Motor department',
    'Property department': 'Property department',
    Classification: 'Classification',
    Category: 'Category',
    Engine: 'Engine',
    Capacity: 'Capacity',
    UXH: 'UXH',
    CSH: 'CSH',
    eSigurime: 'eSigurime',
    ID: 'ID',
    Albania: 'Albania',
    'The Balkans': 'The Balkans',
    Europe: 'Europe',
    '1 Year': '1 Year',
    '1 Month': '1 Month',
    Location: 'Location',
    'Border Vehicle Category': 'Border Vehicle Category',
    Autovetura: 'Autovetura',
    Motocikleta: 'Motorcikleta nga 50-149.9 cc',
    Motokarro: 'Motoricikleta mbi 150 cc',
    'Kamion nga 15-34.99 KV': 'Kamion nga 15-34.99 KV',
    'Kamion nga 35 KV e larte': 'Kamion nga 35 KV e larte',
    Ciklomotor: 'Motorciklete 49 cc',
    Autobus: 'Autobus',
    'Rimorkio kamioni': 'Rimorkio kamioni',
    'Rimorkio autobusi': 'Rimorkio autobusi',
    'Rimorkio te tjera': 'Rimorkio te tjera',
    'Currency Type': 'Currency Type',
    // 'A/1': 'A/1',
    // 'B/1': 'B/1',
    // 'B/2': 'B/2',
    // 'C/1': 'C/1',
    // 'C/2': 'C/2',
    // 'D/1': 'D/1',
    // 'E/1': 'E/1',
    // 'F/1': 'F/1',
    // 'F/2': 'F/2',
    // 'F/3': 'F/3',
    'Tirane Kolaudim': 'Tirane Kolaudim',
    'Dega Qendrore Tirane': 'Dega Qendrore Tirane',
    'Fiscalization: Bizzness Unit': 'Fiscalization: Bizzness Unit',
    'Fiscalization: Operator Code': 'Fiscalization: Operator Code',
    'Bank Account': 'Bank Account',
    'Gjithe Bota': 'Gjithe Bota',
    'Gjithe Bota perjashtuar USA & Canada': 'Gjithe Bota perjashtuar USA & Canada',
    Turkey: 'Turkey',
    Agjent: 'Agjent',
    Banke: 'Bankë',
    Type: 'Type',
    Individual: 'Individual',
    'Travel Cancelation': 'Travel Cancelation',
    'Confirmation Date': 'Confirmation Date',
    'Coverages Options': 'Coverages Options',
    'Luggage Delay': 'Luggage Delay',
    '150 Euro': '150 Euro',
    '500 Euro': '500 Euro',
    '800 Euro': '800 Euro',
    '1000 Euro': '1000 Euro',
    '1500 Euro': '1500 Euro',
    '10000 Euro': '10000 Euro',
    'Urgjenca Mjekesore & Riatdhesim': 'Urgjenca Mjekesore & Riatdhesim',
    'Franchise Limit': 'Franchise Limit',
    'Deductible Limit': 'Deductible Limit',
    'Event Limit': 'Event Limit',
    'Person Limit': 'Person Limit',
    'Period Limit': 'Period Limit',
    'Limit Types': 'Limit Types',
    Enabled: 'Enabled',
    Value: 'Value',
    'Channel Type': 'Channel Type',
    'Scope Type': 'Scope Type',
    Reason: 'Reason',
    ValueCamelCase: 'Value',
    Max: 'Max',
    Min: 'Min',
    MinValue: 'Min. Value',
    MaxValue: 'Max. Value',
    Premium: 'Premium',
    Flat: 'Flat',
    'Sum Insured': 'Sum Insured',
    'Payment Type': 'Payment Type',
    Health: 'Health',
    Coverages: 'Coverages',
    Age: 'Age',
    'Livestock Type': 'Livestock Type',
    'Culture Type': 'Culture Type',
    Area: 'Area',
    'Greenhouse Article Type': 'Greenhouse Article Type',
    'Greenhouse Property Type': 'Greenhouse Property Type',
    Identification: 'Identification',

    'Nr. Serial Polica (Shumë)': 'No. Policy Series (Multiple)',
    'Separate serial numbers with "," or space': 'Separate serial numbers with "," or space',
    'Insured Amount': 'Insured Amount',
    Template: 'Template',
    days: 'days',
    months: 'months',
    years: 'years',
    'Number of Days': 'Number of Days',
    'Iosa ID': 'Iosa ID',
    'User Iosa ID': 'User Iosa ID',
    'Broker Code': 'Broker Code',
    'Display Name Full': 'Full Name',
    'Property Number': 'Property Number',
    'Cadastral Area': 'Cadastral Area',
    Nr: 'No',
    'Property Type': 'Property Type',
    Article: 'Article',
    'Unique Code': 'Unique Code',
    'Surface Area': 'Surface Area',
    'Object name': 'Object name',
    'Travel Cancelation Date': 'Ticket confirmation date',
    'Cadastral Zone': 'Cadastral Zone',
    Dates: 'Dates',
    'Passport Number': 'Passport Number',
    'Beneficiary 2': 'Beneficiary 2',
    Owner: 'Owner',
    'Waiting Period': 'Waiting Period',
    'Select an insurer': 'Select an insurer',
    Invoice: 'Invoice',
    Albanian: 'Albanian',
    'No-Albanian': 'No-Albanian',
    'Release Date': 'Release Date',
    'Policy description': 'Policy description',
    'Full Name': 'Full Name',
    Blocked: 'Blocked',
    'Related Agency': 'Related Agency',
    'Issue Date': 'Issue Date',
    'options.years': 'years',
    'options.year': 'year',
    'options.months': 'months',
    'options.month': 'month',
    'options.days': 'days',
    'options.day': 'day',
    Insurer: 'Insurer',
    'Territorial Coverage': 'Territorial Coverage',
    ClientFromBank: 'Client from Bank',
    DescriptionFromBank: 'Description from Bank',
    'Account Type': 'Account Type',
    'Account Number': 'Account Number',
    'Bank Code': 'Bank',
    'Bank Branches': 'Bank Branches',
    'Activity Address': 'Activity Address',
    'Retroactive Date': 'Retroactive Date',
    Specification: 'Specification',
    'License Number': 'License Number',
    Project: 'Project',
    'Preventive Value': 'Preventive Value',
    NIPT: 'NIPT',
    Publication: 'Publication',
    'Reference Number': 'Reference Number',
    'Procurement Method Type': 'Procurement Method Type',
    'Pershkrim / objekti i tenderit': 'Pershkrim / objekti i tenderit',
    'Data fillimit / tenderit': 'Data fillimit / tenderit',
    'Issued Date From': 'Issued Date From:',
    'Issued Date To': 'Issued Date To:',
    'Cashed premium': 'Cashed premium',
    'Fuel Station Capacity': 'Capacity',
    'Fuel Station Address': 'Address',
    'Fuel Station License Number': 'License Number',
    'Fuel Station Activity License': 'Activity License',
    'Fuel Station Authorization Number': 'Authorization Number',
    'Eurobroker Code': 'Eurobroker Code',
    'Eurobroker Username': 'Eurobroker Username',
    'Eurobroker Password': 'Eurobroker Password',
    Profession: 'Profession',
    Renewal: 'Renewal',
    'Line Of Business': 'Line Of Business',
    'Property Valuation Type': 'Property Valuation Type',
    Index: 'Index',
    'Excise Number': 'Excise Number',
    'Contract Date': 'Contract Date',
    'Insured Profession': 'Insured Profession',
    'Covered Project': 'Covered Project',
    'Age expression': 'Age expression',
    Custom: 'Custom',
    'Period Amount': 'Period Amount',
    'Period Type': 'Period Type',
    'SubLimit Type': 'SubLimit Type',
    'Gender Type': 'Gender Type',
    'Age Expression': 'Age Expression',
    'Sublimit Type': 'Sublimit Type',
    'Is Reinsurance': 'Is Reinsurance',
    'Product reinsurance': 'Product reinsurance',
    'Driving License': 'Driving License',
    'Vehicle Type': 'Vehicle Type',
    'Region Type': 'Region Type',
    'Owner NID': 'Owner NID',
    'Health Coverage Amount': 'Health Coverage Amount',
    'Vessel Flag': 'Vessel Flag',
    _Order: 'Order',
    'Registration Number': 'Registration Number',
    'Panel power': 'Panel power',
    'Concession Object Type': 'Concession Object Type',
    'Account No': 'Account No',
    IBAN: 'IBAN',
    Activity: 'Activity',
    'Navigation Area': 'Navigation Area',
    'Search Country': 'Search country',
    'Go to bank accounts': 'Go to bank accounts',
    'Production Year': 'Production Year',
    'Vessel Display Name': 'Vessel Display Name',
    'Vessel Category': 'Vessel Category',
    'Vessel Material': 'Vessel Material',
    'Engine Power': 'Engine Power',
    'Unique Registration Number': 'Unique Registration Number',
    'Is Rent': 'Is Rent',
    'Vessel Name': 'Vessel Name',
    'Cargo Description': 'Cargo Description',
    'Vehicle Plate': 'Vehicle Plate',
    'Container Name': 'Container Name',
    'Container Number': 'Container Number',
    'Airline Name': 'Airline Name',
    'Extra Explanations': 'Extra Explanations',
    'Transport Documents': 'Transport Documents',
    'Package Type': 'Package Type',
    'Voyage Origin': 'Voyage Origin',
    'Transportation Type': 'Transportation Type',
    'Voyage Destination': 'Voyage Destination',
    'Cargo Type': 'Cargo Type',
    'Hide Premium': 'Hide Premium',
    Dimensions: 'Dimensions',
    'Voyage Destionation': 'Voyage Destionation',
    'Installment Number': 'Installment Number',
    'Interest Rate': 'Interest Rate',
    'Yearly Premium': 'Yearly Premium',
    'Monthly Premium': 'Monthly Premium',
    'Insurance Premium Fee': 'Insurance Premium Fee',
    'Broker Name': 'Broker Name',
    'Broker ID': 'Broker ID',
    'Serial Code': 'Serial Code',
    Sequence: 'Sequence',
    'Product Category Path': 'Product Category Path',
    'Is Esig Fisc Activated': 'Is Esig Fisc Activated',
    'Vehicle license plates': 'Vehicle license plates',
    'Extra Notes': 'Extra Notes',
    'Number Of Vehicles': 'Number Of Vehicles',
    'Daily Exchange Rate': 'Daily Exchange Rate',
    'Posted on': 'Posted on',
    'Invoice exchange rate': 'Invoice exchange rate',
    Account: 'Account',
    'Collection / Payment (Invoice Currency)': 'Collection / Payment (Invoice Currency)',
    'Collection / Payment (Local Currency)': 'Collection / Payment (Local Currency)',
    'New Balance (Invoice Currency)': 'New Balance (Invoice Currency)',
    'New Balance (Local Currency)': 'New Balance (Local Currency)',
    'Balance ALL': 'Balance ALL',
    'Save invoices as mandate entries': 'Save invoices as mandate entries',
    'List of balances': 'List of balances',
    'Calculate balance': 'Calculate balance',
    'Mark as exchange loss': 'Mark as exchange loss',
    'Display the balance': 'Display the balance',
    Restart: 'Restart',
    Action: 'Action',
    'Explicit Number Of Vehicles': 'Explicit Number of Vehicles',
    'Selekto llojin e llogarise': 'Select account type',
    'Is Sailing Vessel': 'Is Sailing Vessel',
    'Sail Area': 'Sail Area',
    'Total Passanger Number': 'Total Passanger Number',
    'Insured Risks': 'Insured Risks',
    'Usage Purpose': 'Usage Purpose',
    'Pilot Names': 'Pilot Names',
    'Territorial Limit': 'Territorial Limit',
    'Vessel Model': 'Vessel Model',
    'Gross Tonnage': 'Gross Tonnage',
    'Certification Number': 'Certification Number',
    Skipper: 'Skipper',
    'Sailing Region': 'Sailing Region',
    'Insured Location': 'Insured Location',
    'Number of Employees': 'Number of Employees',
    'common.ProductType': 'Product type',
    'common.Search': 'Search',
    'common.ProductSerial': 'Policy serial',
    'Age (Years)': 'Age (Years)',
    'Age (Months)': 'Age (Months)',
    'Policy Product': 'Policy Product',
    'Policy Status': 'Policy Status',
    'Client Tax Number': 'Client Tax Number',
    Search: 'Search',
    Make: 'Make',
    Model: 'Model',
    'Serial Number': 'Serial Number',
    'Invoice Number': 'Invoice Number',
    'Purchase Price': 'Purchase Price',
    'Purchase Currency': 'Purchase Currency',
    'Seller Warranty Start Date': 'Seller Warranty Start Date',
    'Seller Warranty End Date': 'Seller Warranty End Date',
    'From End Date': 'From End Date',
    'To End Date': 'To End Date',
    billablePremiumAmount: 'Value of premium to be billed',
    manualAdjustedPremium: 'If you want to adjust billable premium value',
};
